var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayersicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.94864 5.77788L6.43715 5.123L4.26143 5.99346C4.18311 6.02467 4.09151 6.03999 3.99991 6.03999C3.90846 6.03999 3.81701 6.02482 3.73883 5.9936L1.56253 5.12314L0.0511801 5.77788C-0.0176634 5.80749 -0.0169342 5.85431 0.0526387 5.88232L3.87389 7.41088C3.94347 7.43873 4.05636 7.43873 4.12608 7.41088L7.94733 5.88232C8.01676 5.85446 8.01749 5.80749 7.94864 5.77788Z",
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94864 4.01276L6.437 3.35772L4.26143 4.22789C4.18325 4.25925 4.09151 4.27471 4.00006 4.27471C3.90846 4.27471 3.81686 4.25925 3.73854 4.22789L1.56268 3.35772L0.0511801 4.01276C-0.0176634 4.04236 -0.0169342 4.08904 0.0526387 4.11719L3.87389 5.64546C3.94347 5.67317 4.05636 5.67317 4.12608 5.64546L7.94733 4.11704C8.01676 4.08918 8.01749 4.04251 7.94864 4.01276Z",
    fill: "#ADADAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0526387 2.35189L2.04531 3.14899L3.87389 3.88045C3.94347 3.90831 4.05636 3.90831 4.12608 3.88045L5.95524 3.14884L7.94733 2.35204C8.0169 2.32418 8.01734 2.27751 7.94879 2.24761L4.12433 0.590402C4.05563 0.560648 3.94405 0.560648 3.87521 0.590402L0.0511801 2.24761C-0.0176634 2.27736 -0.0169342 2.32418 0.0526387 2.35189Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersicon);
export default __webpack_public_path__ + "static/media/layersicon.c0282d9e86129022cc012303c0ffeec0.svg";
export { ForwardRef as ReactComponent };